import React from 'react';
import { GetStaticProps } from 'next';
import Head from 'next/head';

import { Course, CoursesDocument } from '@edx/graphql/generated';
import { getStaticApolloClient } from '@edx/helpers/apollo';
import { CoursesGrid } from '@edx/components/courses-grid';
import { Title } from '@edx/components/typography';
import { PastDueModal } from '@edx/components/past-due-modal';

export const getStaticProps: GetStaticProps = async () => {
  const { apolloClient } = await getStaticApolloClient();

  const { data } = await apolloClient.query({ query: CoursesDocument });

  return {
    props: {
      initialApolloState: apolloClient.cache.extract(),
      courses: data.courses || [],
    },
  };
};

type Props = {
  courses: Course[];
};

const Courses: React.FC<Props> = ({ courses }) => (
  <>
    <Head>
      <title key="title">Cursos</title>
    </Head>

    <div className="max-w-6xl mx-auto px-4 md:px-10 md:px-6 pt-4 pb-20 md:pt-4">
      <Title tag="h1" className="mt-5 text-white">
        Cursos
      </Title>

      <CoursesGrid courses={courses} />
    </div>

    <PastDueModal />
  </>
);

export default Courses;
